export const generalCursor = {
	borderLeftWidth: '2px',
};

export const generalDiff = {
	insertedTextDecoration: 'none',
	deletedTextDecoration: 'line-through',
	insertedLinePadding: '1px 3px',
	borderRadius: '3px',
};

export const generalGutter = {
	border: 'none',
	paddingRight: '8px',
	fontSize: '0.9em',
	fontWeight: '500',
	lineHeight: '1.78',
};

export const generalPanel = {
	border: 'none',
	borderRadius: '4px',
	padding: '2px 10px',
};

export const generalLine = {
	borderRadius: '2px',
};

export const generalMatching = {
	borderRadius: '2px',
};

export const generalPlaceholder = {
	borderRadius: '4px',
	padding: '0 5px',
	margin: '0 2px',
};

export const generalScroller = {
	width: '12px',
	height: '12px',
	borderRadius: '6px',
};

export const generalSearchField = {
	borderRadius: '4px',
	padding: '2px 6px',
};

export const generalTooltip = {
	borderRadius: '4px',
	borderRadiusSelected: '3px',
	lineHeight: '1.3',
	padding: '4px 8px',
	paddingRight: '8px',
};

export interface IMergeRevertStyles {
	backgroundColor: string;
	borderColor: string;
	buttonColor: string;
	buttonHoverColor: string;
}

export const mergeRevertStyles: IMergeRevertStyles = {
	backgroundColor: 'var(--ui-bg-elevated)',
	borderColor: 'var(--ui-border)',
	buttonColor: 'var(--ui-text)',
	buttonHoverColor: 'var(--ui-bg-accented)',
};

export function applyMergeRevertStyles(styles: IMergeRevertStyles) {
	const styleEl = document.createElement('style');
	styleEl.id = 'cm-merge-revert-styles';

	styleEl.textContent = `
      .cm-merge-revert {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 4px;
        background-color: ${styles.backgroundColor};
        border-left: 1px solid ${styles.borderColor};
        border-right: 1px solid ${styles.borderColor};
        width: 32px;
      }

      .cm-merge-revert button {
        width: 100%;
        height: auto;
        background-color: transparent;
        border: none;
        color: ${styles.buttonColor};
        cursor: pointer;
        margin: 0 auto;
        font-size: 20px;
      }

      .cm-merge-revert button:hover {
        background-color: ${styles.buttonHoverColor};
      }
    `;

	const existingStyle = document.querySelector('#cm-merge-revert-styles');
	if (existingStyle) existingStyle.remove();

	document.head.append(styleEl);
}
